import { debug } from "tone";
import Entity from "/src/js/engine/entity";
import Hitbox from "/src/js/engine/hitbox";
import Explosion from "../explosion";

export default class BassNote extends Entity{
    constructor({engine, note}){
        super({engine,type:"note"});
        this.note = note;
        this.speed = 1500;
        this.startPosition = {
            x: this.engine.width + note.time * this.speed,
            y: (this.note.midi/128) * this.engine.height  + Math.sin(this.note.time * Math.PI * 0.5) * 300 + 100,
        };
        this.position = {x:this.startPosition.x,y:this.startPosition.y};
        this.playing = false;
        this.timer = 0;
        this.hitbox = new Hitbox({...this.position, w:30, h:30});
    }

    update(){
        const s = this.engine.scaleFactor;
        this.timer += this.engine.time.delta;
        this.playing = this.timer >= this.note.time && this.timer <= this.note.time + this.note.duration;
        this.position.x = this.engine.width + this.note.time * this.speed  * s - this.timer * this.speed * s;
        this.scale = (this.timer - this.note.time) / (this.note.duration);
        if(this.scale < 0) this.scale = 0; if(this.scale > 1) this.scale = 1;
    }

    render(ctx){
        const s = this.engine.scaleFactor;
        let w = (this.note.duration * this.speed - 5) * s;
        let h = 30 * s;

        if(this.position.x > this.engine.width || this.position.x < -w) return;

        ctx.save();
        ctx.translate(this.position.x, this.position.y);

        //gradient
        let gradient = ctx.createLinearGradient(0, -h/2, w * this.scale, h);
        if(this.playing){
            gradient.addColorStop(0, 'rgba(255,0,0,0.15)');
            gradient.addColorStop(1, 'rgba(255,0,0,0)');
        }else{
            gradient.addColorStop(0, 'rgba(255,255,255,0.15)');
            gradient.addColorStop(1, 'rgba(255,255,255,0)');
        }
        ctx.fillStyle = gradient;

        //trail
        ctx.beginPath(); 
        ctx.lineTo(h/2, h/2);
        ctx.lineTo(h/2, -h/2);
        ctx.lineTo(w * this.scale, 0);
        ctx.fill();

        //circle
        ctx.fillStyle = this.playing ? "red" : "white";
        ctx.beginPath();
        ctx.arc( h/2, 0, h/2, 2 * Math.PI, false);
        ctx.fill();

        ctx.restore();

        this.hitbox.set({x: this.position.x + h/2 ,y: this.position.y, w: h, h});
    }

    hit(){
        new Explosion({engine: this.engine, position: this.position, size: 300});
        this.engine.destroyEntity(this);
    }

    kill(){
        const s = this.engine.scaleFactor;
        let w = (this.note.duration * this.speed - 5) * s;
        if(this.position.x < this.engine.width && this.position.x > -w){
            new Explosion({engine: this.engine, position: this.position, size: 300});
        }   
        this.engine.destroyEntity(this);
    }
}
